<template>
  <page>
    <template slot="header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark">
              {{ $t('Lista de execução') }}
            </h3>
          </div>
          <div class="col-sm-6">
            <!-- <b-breadcrumb
              class="float-sm-right"
              :items="breadcrumbItems"
            ></b-breadcrumb> -->
          </div>
        </div>
      </div>
    </template>

    <template slot="content">
      <div class="row">
        <div class="col-12">
          <execucoes-ativas></execucoes-ativas>
        </div>
      </div>
    </template>
    <template slot="content">
      <div class="row">
        <div class="col-12">
          <os-em-pause></os-em-pause>
        </div>
      </div>
    </template>
    <template slot="content">
      <div class="row">
        <div class="col-12">
          <os-aguardando-aprovacao></os-aguardando-aprovacao>
        </div>
      </div>
    </template>
    <template slot="content">
      <div class="row">
        <div class="col-12">
          <os-aguardando-liberacao></os-aguardando-liberacao>
        </div>
      </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import ExecucoesAtivas from '@/components/ExecucoesAtivas'
import OsEmPause from '@/components/OsEmPause'
import OsAguardandoAprovacao from '@/components/OsAguardandoAprovacao'
import OsAguardandoLiberacao from '@/components/OsAguardandoLiberacao'

export default {
  components: {
    Page,
    ExecucoesAtivas,
    OsEmPause,
    OsAguardandoAprovacao,
    OsAguardandoLiberacao
  },

  data () {
    return {
      breadcrumbItems: [
        {
          text: 'Lista de execução',
          active: true
        }
      ],
      visible: null
    }
  }
}
</script>
